/**
 * Node modules
 */
import React from 'react';

export default React.memo(props => (
  <svg
    fill="currentColor"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>
      Reader Outline
    </title>
    <rect
      fill="none"
      height="416"
      rx="48"
      ry="48"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="32"
      width="320"
      x="96"
      y="48"
    />
    <line
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="32"
      x1="176"
      x2="336"
      y1="128"
      y2="128"
    />
    <line
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="32"
      x1="176"
      x2="336"
      y1="208"
      y2="208"
    />
    <line
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="32"
      x1="176"
      x2="256"
      y1="288"
      y2="288"
    />
  </svg>
));
